import React, { useEffect, useState } from "react";

const Header = () => {
  return (
    <>
      <header className="bg-white shadow-md px-4 flex justify-between items-center">
        <img
          className="h-20 mr-4 pr-2 cursor-pointer py-5"
          src={`${process.env.REACT_APP_SITE_URL}leda-group/logo-withbg.png`}
        />
        <nav className="space-x-4 text-sm md:text-lg">
          <a
            href={`${process.env.REACT_APP_SITE_URL}leda-group/`}
            className="hover:underline"
          >
            Home
          </a>
          <a
            href={`${process.env.REACT_APP_SITE_URL}682afc064e30fe1a6c969ab3/career?page=leda`}
            className="hover:underline"
          >
            Careers
          </a>
          <a
            href={`${process.env.REACT_APP_SITE_URL}leda-group/about`}
            className="hover:underline"
          >
            About LEDA
          </a>
        </nav>
      </header>
      <section className="relative bg-[#111827] py-16 text-white">
        <div className="container px-4 md:px-6">
          <div className="mx-auto max-w-4xl">
            <div className="flex flex-col items-center gap-6 md:flex-row md:items-center md:gap-8">
              <div className="text-center md:text-left ">
                <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl lg:text-5xl">
                  LEDA Group
                </h1>
                <p className="mt-4 text-lg text-primary">
                  Construction Recruitment Specialists
                </p>

                {/*
              <div className="mt-12 flex justify-between w-full">
                <div className="flex flex-col">
                  <label>Looking to hire?</label>
                  <a
                    href="mailto:info@leda-group.co.uk"
                    className="bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-full text-lg mt-5"
                  >
                    Contact us
                  </a>
                </div>
                <div className="flex flex-col">
                  <label>Looking for work?</label>
                  <a
                    href={`${process.env.REACT_APP_SITE_URL}682afc064e30fe1a6c969ab3/career`}
                    className="bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-full text-lg mt-5"
                  >
                    Careers
                  </a>
                </div>
              </div>
              */}
              </div>
            </div>
          </div>
        </div>
        {/*
      <div className="px-4 md:px-6">
        <div className="mx-auto">
          <div className="flex flex-col items-center gap-6 md:flex-row md:items-center md:gap-8 justify-center">
            <div className="text-center">
              <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl lg:text-5xl">
                LEDA Group
              </h1>
              <p className="text-sm">Construction Recruitment Specialists</p>
              <img src="/leda-group/logo.png" className="h-auto w-80" />
      <div className="mt-12 flex justify-between w-full">
        <div className="flex flex-col">
          <label>Looking to hire?</label>
          <a
            href="mailto:info@leda-group.co.uk"
            className="bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-full text-lg mt-5"
          >
            Contact us
          </a>
        </div>
        <div className="flex flex-col">
          <label>Looking for work?</label>
          <a
            href={`${process.env.REACT_APP_SITE_URL}682afc064e30fe1a6c969ab3/career`}
            className="bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-full text-lg mt-5"
          >
            Careers
          </a>
        </div>
      </div>
    </div>
  </div>
        </div >
      </div >
      */}
      </section>
    </>
  );
};

export default Header;
